module.exports = __webpack_public_path__ + "f1b4ac54b87015f3ef268a1fad69b05c.svg";